import axios from "axios";
import { getBrowserDeviceId, getPlatform } from "shared/utils/common-utils";
import { API_SSO_LOGIN } from "./endpoint";
import local from 'store2';

export const ssoLogin = (data) => {
    return axios.post(API_SSO_LOGIN+data,{platform: getPlatform(), deviceId: getBrowserDeviceId()});//Bug #1072 @Author Aby @date 27Oct2022
};